// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgFilterHeart: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path
          fillRule="evenodd"
          d="M8.721 3.877c0 .041 0 .082.002.123H1a1 1 0 1 0 0 2h8.3c.492.907 1.24 1.708 2.004 2.38l-.004.004c.79.693 1.569 1.207 2.007 1.475l1.058.647 1.05-.66c.408-.257 1.18-.766 1.973-1.452l.003-.002c.776-.672 1.53-1.479 2.027-2.392H23a1 1 0 1 0 0-2h-3.002L20 3.867A3.836 3.836 0 0 0 17.547.24 3.574 3.574 0 0 0 16.248 0a3.38 3.38 0 0 0-1.883.571c-1.295-.88-2.687-.516-3.19-.32C10.04.69 8.722 1.907 8.722 3.876m3.9 2.998.002.001.017.015-.021-.01.017.014.001.001a13.155 13.155 0 0 0 1.713 1.256 14.446 14.446 0 0 0 1.731-1.272C17.333 5.796 18 4.753 18 3.867c0-.98-.636-1.565-1.178-1.763A1.563 1.563 0 0 0 16.248 2c-.132 0-.275.018-.423.065a1.524 1.524 0 0 0-.682.467l-.783.897-.782-.897a1.496 1.496 0 0 0-.683-.465 1.528 1.528 0 0 0-.996.048 1.859 1.859 0 0 0-1.178 1.762c0 .165.023.335.069.51.118.152.194.34.208.543.277.56.76 1.155 1.432 1.773.063.057.126.115.192.172"
          clipRule="evenodd"
        />
        <path
          fillRule="evenodd"
          d="M1 18a1 1 0 1 0 0 2h3.606c.47.701 1.079 1.33 1.698 1.874l-.004.005c.79.692 1.569 1.207 2.007 1.475L9.365 24l1.05-.66c.408-.257 1.18-.765 1.973-1.452l.003-.002c.63-.545 1.244-1.179 1.72-1.886H23a1 1 0 0 0 0-2h-8.053c.035-.21.053-.422.053-.639a3.836 3.836 0 0 0-2.453-3.626 3.575 3.575 0 0 0-1.299-.24 3.38 3.38 0 0 0-1.883.57c-1.295-.88-2.687-.516-3.19-.32-1.135.439-2.454 1.657-2.454 3.626 0 .214.018.423.051.629zm6.622 2.37a8.315 8.315 0 0 1-.192-.173c-1.116-1.025-1.709-1.99-1.709-2.826 0-.97.636-1.553 1.178-1.762.19-.074.576-.18.996-.048.227.071.463.212.683.465l.783.897.782-.897c.22-.252.456-.394.682-.466.148-.048.291-.066.423-.066.24 0 .449.053.574.105.542.198 1.178.782 1.178 1.762 0 .886-.667 1.93-1.919 3.014a14.591 14.591 0 0 1-1.73 1.272 13.158 13.158 0 0 1-1.714-1.256l-.001-.001-.017-.015.02.01z"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgFilterHeart);
export default Memo;
